import type { FunctionComponent } from 'react';
import Icon, { icons } from './Icon';

type ChipProps = {
  text: string;
  size?: 'small' | 'medium' | 'large';
  isDisabled?: boolean;
  onDelete: () => void;
};

/**
 * Simple, generic chip component.
 * Just one style right now, but could be expanded and improved in the future.
 *
 * @param {ChipProps} props - Chip props
 * @param {string} props.text - The content of the chip.
 * @param {'small' | 'medium' | 'large'} [props.size] - Size of the chip.
 * @param {() => void} props.onDelete - Callback to delete the chip.
 */
const Chip: FunctionComponent<ChipProps> = ({
  text,
  size = 'medium',
  isDisabled = false,
  onDelete,
}) => (
  <span className={`fossa-chip fossa-chip--${size}`}>
    <span className="fossa-chip--layout">
      {text}
      {' '}
      <button
        type="button"
        onClick={onDelete}
        className="fossa-chip__delete-btn"
        disabled={isDisabled}
      >
        <Icon icon={icons.times} />
      </button>
    </span>
  </span>
);

export default Chip;
